<ng-container *ngIf="this.countWithAdditionalDataAccount">
    &nbsp;<span class="badge badge-pill badge-info">{{ this.countWithAdditionalDataAccount }} media</span>
</ng-container>